namespace Areas.WebsiteInfo.RFQ {
    "use strict";

    let rfqId: number;
    const baseUrl = "/WebsiteInfo/RFQ";


    export function onGridSelectionChanged(e: any) {
        var rowData: any = e.selectedRowsData[0];

        var rowForm: any = $("#RFQForm").dxForm("instance");
        rowForm.option("formData", rowData);

        let selectedRows = e.component.getSelectedRowsData();
        rfqId = selectedRows[0].websiteRFQId;
    }

    export function onRFQContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);
    }

    export function addRFQ() {
        const form = $("#RFQForm").dxForm("instance");
        rfqId = 0;

        $.get(`${baseUrl}/AddRFQ/${rfqId}`,
            (data) => {
                form.option("formData", data);
            });
    }

    export function updateRFQWebsite(a) {

        sendRequest("/WebsiteInfo/RFQ/UpdateRFQPublicWebsite",
            null,
            "PUT");

        return;
    }

    export function updateRFQ() {
        const form = $("#RFQForm").dxForm("instance");
        const newData: any = form.option("formData");

        if (newData.websiteRFQId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }

    function saveRecord(newData: any) {
        const url = `${baseUrl}/RFQPost`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function updateRecord(newData: any) {
        const url = `${baseUrl}/RFQPut/${rfqId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#RFQForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.accountId = data.accountId;
            formData.projectName = data.projectName;
            formData.projectNumber = data.projectNumber;
            formData.projectCCNumber = data.projectCCNumber;

            form.option("formData", formData);
        }
    }

    export function selectAccount() {
        const form: any = $("#RFQForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }


    export function selectVendorExecutive() {
        const vendorDialog = new Areas.Dialogs.VendorDialog(dialogVendorClosing("VendorExecutive"));
    }

    export function selectVendorDesign() {
        const vendorDialog = new Areas.Dialogs.VendorDialog(dialogVendorClosing("VendorDesign"));
    }

    function dialogVendorClosing(buttonId: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#RFQForm").dxForm("instance");
            const formData: any = form.option("formData");

            if (buttonId === "VendorExecutive") {
                formData.vendorExecutiveArchitectId = data.vendorId;
                formData.vendorExecutiveArchitect = data.vendorName;

            } else if (buttonId === "VendorDesign") {
                formData.vendorDesignArchitectId = data.vendorId;
                formData.vendorDesignArchitect = data.vendorName;
            }
            form.option("formData", formData);
        }
    } 


    export function selectContactVendorExecutive() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogContactClosing("ContactVendorExecutive"));
    }

    export function selectContactVendorDesign() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogContactClosing("ContactVendorDesign"));
    }

    function dialogContactClosing(buttonId: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#RFQForm").dxForm("instance");
            const formData: any = form.option("formData");

            if (buttonId === "ContactVendorExecutive") {
                formData.contactExecutiveArchitectId = data.contactId;
                formData.contactExecutiveName = data.displayName;

            } else if (buttonId === "ContactVendorDesign") {
                formData.contactDesignArchitectId = data.contactId;
                formData.contactDesignName = data.displayName;
            }
            form.option("formData", formData);
        }
    } 
}